$(document).ready(function() {

  $(".posts--load--more-a").on('click',function(e) {
    e.preventDefault();
    let paged    = parseFloat( $(this).attr('data-next') );
    let sector   = $('#post-filter--sector').val();
    let strategy = $('#post-filter--strategy').val();
    let region   = $('#post-filter--region').val();
    let keyword  = $('#post--search-input').val();
    let category_name  = $('#category_name').val();
    updatePostsResults(paged, sector, strategy, region, keyword, category_name);
  });

  var updatePostsResults = function( paged, sector, strategy, region, keyword, category_name ) {

    // console.log('paged => ' + paged);
    // console.log('sector => ' + sector);
    // console.log('strategy => ' + strategy);
    // console.log('region => ' + region);
    // console.log('keyword => ' + keyword);

    paged    = paged ? paged : 1;
    var grid = $('.posts--grid');

    $.ajax({
      type     : "post",
      dataType : "json",
      url      : localized_object.ajax_url,
      data : {
        action : "get_posts_form",
        paged    : paged,
        sector   : sector,
        strategy : strategy,
        region   : region,
        keyword  : keyword,
        paged    : paged,
        category_name  : category_name,
        nonce    : localized_object.nonce
      },
      //processData: false,
      timeout    : 300000,
      beforeSend : function() {
        grid.addClass('is-loading');
      }
    }).done( function( response ) {

      grid.removeClass('is-loading');
      //console.log(response);
      // const obj = JSON.parse(response);
      //       console.log(obj);

      if ( response && typeof response.news !== 'undefined' ) {

        var count = $('.cur-num').text();
        count = parseFloat(count) + parseFloat(response.displaying);

        var newPosts = $( response.news );

        if ( !response.news ) {
          grid.html('<h3 class="posts--no-results"><strong>No Results</strong> Please refine search parameters</h3>');
        } else if (response.cur_page == 1) {
          grid.html(newPosts);
        } else {
          grid.append(newPosts);
        }

        $('.posts--navigation--page-links').html(response.page_links);

        $(".posts--load--more-a").attr('data-next', response.cur_page + 1 );

        if ( parseFloat(response.max_count) < response.cur_page * 10 ) {
          $('.cur_displaying').html(parseFloat(response.max_count));
        } else {
          $('.cur_displaying').html(response.cur_page * 10);
        }

        $('.max_count').html(parseFloat(response.max_count));

        if ( response.cur_page < response.max_pages ) {
          $(".posts--load--more-a").show();
        } else {
          $(".posts--load--more-a").hide();
        }

      }

    }).fail(function(xhr, status, error) {
      //Ajax request failed.
      console.log(error);
      var errorMessage = xhr.status + ': ' + xhr.statusText
      console.log('Error - ' + errorMessage);

    }).always(function() {



    });

  }

	$('.post--item a').on('click',function(e) {

		e.preventDefault();
		var href     = $(this).attr('href');
		var status   = $('.post--filter-status').val();
		var industry = $('.post--filter-industry').val();
		var query    = '';

		if ( status || industry ) {

			query    = '?';

			if ( status ) {
				query += 'st=' +status;
			}

			if ( industry ) {
				query += '&ind=' +industry;
			}

			href = href + query;

		}

		if (history.pushState) {
			var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + query;
			window.history.pushState({path:newurl},'',newurl);
		}

		window.location.href = href;

	});

	if ( $('.post--dropdown').length > 0 ) {

    if ( $('html').hasClass('is-touch') ) {

      $('.post--dropdown').on('change', function(e) {
        e.preventDefault();
        let sector   = $('#post-filter--sector').val();
        let strategy = $('#post-filter--strategy').val();
        let region   = $('#post-filter--region').val();
        let keyword  = $('#post--search-input').val();
        let category_name  = $('#category_name').val();
        updatePostsResults('', sector, strategy, region, keyword, category_name);
      });

    } else {

  		$('.post--dropdown').selectric({
        maxHeight: 300,
        disableOnMobile: true
      }).on('change', function(e, element, selectric) {
  			e.preventDefault();
        let sector   = $('#post-filter--sector').val();
        let strategy = $('#post-filter--strategy').val();
        let region   = $('#post-filter--region').val();
        let keyword  = $('#post--search-input').val();
        let category_name  = $('#category_name').val();
        updatePostsResults('', sector, strategy, region, keyword, category_name);
  		});

    }

	}

  $('#post--search-button').on('click',function(e) {
    let sector   = $('#post-filter--sector').val();
    let strategy = $('#post-filter--strategy').val();
    let region   = $('#post-filter--region').val();
    let keyword  = $('#post--search-input').val();
    let category_name  = $('#category_name').val();
    console.log("category_name:",category_name);
    updatePostsResults('', sector, strategy, region, keyword, category_name);
  });

  $('.post--reset-filter-a').on('click',function(e) {
    e.preventDefault();
    resetFilters();
  });

  function resetFilters() {
    $('.post--dropdown').val("").selectric('refresh');
    $('#post--search-input').val("");
    $('.post--item').removeClass('is-hiding');
    updatePostsResults('', '', '', '', '', '');
  }

  function filterPost() {

    $('#post--search-input').val("");

    var classesArray = [];
    var posts        = $('.post--item');

    $('.post--dropdown').each(function(){

      var selectClass = $(this).val();

      if (selectClass) {
        classesArray.push(selectClass);
      }

    });

    if (classesArray.length > 0) {

      posts.each(function() {

        var shouldHide = false;
        var portItem  = $(this);

        $.each(classesArray, function(i,val) {

          if ( !portItem.hasClass(val) ) {
            shouldHide = true;
          }

        });

        if (shouldHide) {
          $(this).addClass('is-hiding');
        } else {
          $(this).removeClass('is-hiding');
        };

      });

    } else {

      $('.post--item').removeClass('is-hiding');

    }

  }

  function searchPost( value ) {

    var tagValue   = value;
    var posts = $('.post--item');

		if (tagValue && tagValue.length > 2) {

			posts.each(function() {

				var shouldHide = false;
				var portItem   = $(this);
        var tags       = portItem.data('searchtags');

				if ( !tags.includes(tagValue) ) {
					shouldHide = true;
				}

				if (shouldHide) {
					$(this).addClass('is-hiding');
				} else {
					$(this).removeClass('is-hiding');
				};

			});

		} else {

			posts.removeClass('is-hiding');

    }

  }

});
